<template>
	<div>
		<div class="sr-only">{{ tg("loading") }}</div>

		<v-placeholder
			aria-hidden="true"
			class="aspect-square rounded-2xs bg-gray-50 before:via-gray-100"
		/>

		<div aria-hidden="true" class="p-2">
			<v-placeholder
				class="mb-1 h-5 w-1/3 rounded-2xs bg-gray-50 before:via-gray-100"
			/>

			<v-placeholder
				class="mb-2 h-4 w-1/2 rounded-2xs bg-gray-50 before:via-gray-100"
			/>

			<v-placeholder
				class="mb-4 h-7 w-1/6 rounded-2xs bg-gray-50 before:via-gray-100"
			/>

			<v-placeholder
				class="h-4 w-1/3 rounded-2xs bg-gray-50 before:via-gray-100"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
const {t: tg} = useI18n({useScope: "global"});
</script>
